import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (credentials) => api.post('/auth/login', credentials);
export const verifyToken = () => api.post('/auth/verify');

// Contact
export const submitContact = (data) => api.post('/contact/submit', data);

// Company
export const getCompanyInfo = () => api.get('/content/company');
export const updateCompanyInfo = (data) => api.put('/content/company', data);

// Vision & Mission
export const getVisionMission = () => api.get('/content/vision-mission');
export const updateVisionMission = (data) => api.put('/content/vision-mission', data);

// Products
export const getProducts = () => api.get('/products');
export const createProduct = (data) => api.post('/products', data);
export const updateProduct = (id, data) => api.put(`/products/${id}`, data);
export const deleteProduct = (id) => api.delete(`/products/${id}`);

// Innovations
export const getInnovations = () => api.get('/innovations');
export const createInnovation = (data) => api.post('/innovations', data);
export const updateInnovation = (id, data) => api.put(`/innovations/${id}`, data);
export const deleteInnovation = (id) => api.delete(`/innovations/${id}`);

// USPs
export const getUSPs = () => api.get('/usps');
export const createUSP = (data) => api.post('/usps', data);
export const updateUSP = (id, data) => api.put(`/usps/${id}`, data);
export const deleteUSP = (id) => api.delete(`/usps/${id}`);

// Stats
export const getStats = () => api.get('/content/stats');
export const updateStats = (data) => api.put('/content/stats', data);

// Inquiries
export const getInquiries = () => api.get('/admin/inquiries');
export const updateInquiryStatus = (id, status) => api.put(`/admin/inquiries/${id}/status`, { status });
export const deleteInquiry = (id) => api.delete(`/admin/inquiries/${id}`);

export default api;
